import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/img/logo1.png";

const NAV_ITEMS = ["home", "Our Story", "Founders", "pricing", "Contact"];
const label = (id) => (id === "home" ? "Home" : id.charAt(0).toUpperCase() + id.slice(1));

export default function Navbar({ active, setActive }) {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const handleNav = (id) => {
    setActive(id);
    setMenuOpen(false);
  };

  return (
    <nav style={s.nav}>
      <div style={s.inner}>
        <img src={logo} alt="Verisaya" style={s.logo} />

        {/* Desktop links */}
        {!isMobile && (
          <div style={s.links}>
            {NAV_ITEMS.map((id) => (
              <button key={id} onClick={() => handleNav(id)}
                style={{ ...s.link, ...(active === id ? s.activeLink : {}) }}>
                {label(id)}
              </button>
            ))}
          </div>
        )}

        {/* Desktop login */}
        {!isMobile && (
          <button style={s.loginBtn} onClick={() => navigate("/login")}>Login</button>
        )}

        {/* Burger — mobile only */}
        {isMobile && (
          <button style={s.burger} onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="#818A9D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              {menuOpen
                ? <><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></>
                : <><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" /></>
              }
            </svg>
          </button>
        )}
      </div>

      {/* Mobile dropdown */}
      {isMobile && menuOpen && (
        <div style={s.mobileMenu}>
          {NAV_ITEMS.map((id) => (
            <button key={id} onClick={() => handleNav(id)}
              style={{ ...s.mobileLink, ...(active === id ? s.mobileLinkActive : {}) }}>
              {label(id)}
            </button>
          ))}
          <button style={s.mobileLoginBtn} onClick={() => { navigate("/login"); setMenuOpen(false); }}>
            Login
          </button>
        </div>
      )}
    </nav>
  );
}

const s = {
  nav:            { position: "sticky", top: 0, zIndex: 999, background: "#080d20", borderBottom: "1px solid #212637", fontFamily: "'Segoe UI', sans-serif" },
  inner:          { maxWidth: 1200, margin: "0 auto", padding: "0 24px", height: 64, display: "flex", alignItems: "center", justifyContent: "space-between" },
  logo:           { height: 40, objectFit: "contain" },
  links:          { display: "flex", gap: 36, alignItems: "center" },
  link:           { background: "none", border: "none", cursor: "pointer", fontSize: 14, color: "#818A9D", fontWeight: 500, fontFamily: "'Segoe UI', sans-serif" },
  activeLink:     { color: "#fff" },
  loginBtn:       { background: "#998046", border: "none", cursor: "pointer", borderRadius: 8, fontSize: 14, color: "#fff", fontWeight: 600, padding: "8px 20px", fontFamily: "'Segoe UI', sans-serif" },
  burger:         { background: "none", border: "none", cursor: "pointer", padding: 6, display: "flex", alignItems: "center", justifyContent: "center" },
  mobileMenu:     { background: "#0d1526", borderTop: "1px solid #1e2e45", padding: "8px 16px 16px", display: "flex", flexDirection: "column", gap: 2 },
  mobileLink:     { background: "none", border: "none", cursor: "pointer", fontSize: 15, color: "#818A9D", fontWeight: 500, textAlign: "left", padding: "11px 12px", borderRadius: 8, fontFamily: "'Segoe UI', sans-serif" },
  mobileLinkActive: { background: "#13202d", color: "#fff" },
  mobileLoginBtn: { marginTop: 8, background: "#998046", border: "none", cursor: "pointer", borderRadius: 8, fontSize: 14, color: "#fff", fontWeight: 600, padding: "11px 16px", fontFamily: "'Segoe UI', sans-serif", textAlign: "left" },
};
